import AnimalHatOMaticMain from "./Main";

function AnimalHatOMatic() {
  return (
    <div>
      <h1>Animal Hat O Matic</h1>
      <AnimalHatOMaticMain />
    </div>
  );
}

export default AnimalHatOMatic;
